import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComingSoonPage() {
  return <div className="min-h-screen bg-black flex items-center justify-center px-4" data-id="element-217" data-mp="2sieyq30fhuf0">
      <div className="max-w-2xl mx-auto text-center" data-id="element-218" data-mp="2xijiq30jp79z">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.6
      }} data-id="element-219" data-mp="32augp0bq6izw">
          <Clock className="w-20 h-20 text-[#C5A55A] mx-auto mb-8" data-id="element-220" data-mp="3cald57juj82m" />
          <h1 className="text-5xl md:text-7xl font-bold font-serif text-white mb-6" data-id="element-221" data-mp="3gavhygvwjsfw">
            Coming Soon
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-222" data-mp="3l7cfu2swll66">
            Our Customer Login Portal is currently under development. Check back
            soon for secure access to your project information and documents.
          </p>
          <Link to="/" className="inline-block bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 text-lg font-bold rounded-sm transition-colors" data-id="element-223" data-mp="1espw1mifxklm">
            Return Home
          </Link>
        </motion.div>
      </div>
    </div>;
}